import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FeatureComponentMode} from "@core/enums/core.enums";

@Component({
  selector: 'ag-mode-switch',
  templateUrl: './ag-mode-switch.component.html',
  styleUrls: ['./ag-mode-switch.component.scss']
})
export class AgModeSwitchComponent implements OnInit {

  @Output() newMode :EventEmitter<string>= new EventEmitter();
  @Input() initialMode: string | undefined;

  label: { data:string, visual: string } = {data: "Data", visual: "Visuals"};
  currentMode: string = FeatureComponentMode.DATA;

  switchMode(mode: string): void {
    this.currentMode = mode;
    this.newMode.emit(mode);
  }

  isDataMode(): boolean {
    return this.currentMode.toLowerCase() === 'data';
  }

  ngOnInit() {
    if(this.initialMode) this.currentMode = this.initialMode;
  }

  protected readonly FeatureComponentMode = FeatureComponentMode;
}
